import { useEffect, useState } from "react";
import api from "../api/api";

function AssignVendor() {
  const [vendors,  setVendors]  = useState([]);
  const [areas,    setAreas]    = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [areaId,   setAreaId]   = useState("");
  const [loading,  setLoading]  = useState(false);
  const [msg,      setMsg]      = useState("");

  useEffect(() => {
    api.get("/admin/vendors")
      .then(res => { const d = res.data.data || res.data; setVendors(Array.isArray(d) ? d : []); })
      .catch(() => {});

    api.get("/admin/areas")
      .then(res => { const d = res.data.data || res.data; setAreas(Array.isArray(d) ? d : []); })
      .catch(() => {});
  }, []);

  const assign = async () => {
    if (!vendorId || !areaId) { setMsg("error:Select both vendor and area"); return; }
    setLoading(true); setMsg("");
    try {
      await api.post("/admin/assign", { vendorId, areaId });
      setMsg("success:Vendor assigned successfully!");
      setVendorId(""); setAreaId("");
    } catch {
      setMsg("error:Assignment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [msgType, msgText] = msg ? msg.split(/:(.+)/) : ["", ""];

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">🔗 Assign Vendor to Area</div>
      </div>
      <div className="card-body">
        {msgText && (
          <div className={`alert ${msgType === "success" ? "alert-success" : "alert-error"} mb-16`}>
            {msgType === "success" ? "✓" : "⚠"} {msgText}
          </div>
        )}

        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Select Vendor *</label>
            <select className="form-select" value={vendorId}
              onChange={e => setVendorId(e.target.value)}>
              <option value="">-- Select Vendor --</option>
              {vendors.map(v => (
                <option key={v.vendorId} value={v.vendorId}>{v.name} ({v.phone})</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Select Area *</label>
            <select className="form-select" value={areaId}
              onChange={e => setAreaId(e.target.value)}>
              <option value="">-- Select Area --</option>
              {areas.map(a => (
                <option key={a.areaId} value={a.areaId}>{a.name}</option>
              ))}
            </select>
          </div>
        </div>

        <button className="btn btn-gold mt-16" onClick={assign} disabled={loading}>
          {loading ? "Assigning…" : "🔗 Assign Vendor"}
        </button>
      </div>
    </div>
  );
}

export default AssignVendor;
